// import React, { useState } from "react";
// import "./apiendpoint1.css";

// const APIForm = () => {
//   const [optVaahan, setOptVaahan] = useState(false);
//   const [category, setCategory] = useState("Post");
//   const [link, setLink] = useState("");
//   const [apiDescription, setApiDescription] = useState(["Name", "Case ID"]);
//   const [newDescription, setNewDescription] = useState("");

//   const handleCheckboxChange = () => {
//     setOptVaahan(!optVaahan);
//   };

//   const handleCategoryChange = (e) => {
//     setCategory(e.target.value);
//   };

//   const handleLinkChange = (e) => {
//     setLink(e.target.value);
//   };

//   const handleNewDescriptionChange = (e) => {
//     setNewDescription(e.target.value);
//   };

//   const addDescription = () => {
//     if (newDescription.trim() !== "") {
//       setApiDescription([...apiDescription, newDescription.trim()]);
//       setNewDescription(""); // Clear input after adding
//     }
//   };

//   const removeDescription = (index) => {
//     const updatedDescriptions = apiDescription.filter((_, i) => i !== index);
//     setApiDescription(updatedDescriptions);
//   };

//   const addApiEndpoint = () => {
//     // alert("API Endpoint Added!");
//   };

//   return (
//     <div className="api-form">
//       <h2 className="api-heading">API</h2>

//       <label className="checkbox-label">
//         <input
//           type="checkbox"
//           checked={optVaahan}
//           onChange={handleCheckboxChange}
//         />
//         <span className="checkbox-text">Opt for VAAHAN API</span>
//       </label>

//       <div className="input-group">
//         <label>Category</label>
//         <select value={category} onChange={handleCategoryChange}>
//           <option value="Post">Post</option>
//           <option value="Pre">Pre</option>
//           <option value="Complete">Complete</option>
//           <option value="Incomplete">Incomplete</option>
//         </select>
//       </div>

//       <div className="input-group">
//         <label>Link</label>
//         <input
//           type="text"
//           value={link}
//           onChange={handleLinkChange}
//           placeholder="Enter API link"
//         />
//       </div>

//       <div className="input-group">
//         <label>API description</label>
//         <div className="api-description">
//           {apiDescription.map((desc, index) => (
//             <span key={index} className="tag">
//               {desc} {" "}
//               <span
//                 className="remove-tag"
//                 onClick={() => removeDescription(index)}
//               >
//                 ×
//               </span>
//             </span>
//           ))}
//         </div>
//         <div className="add-description">
//           <input
//             type="text"
//             value={newDescription}
//             onChange={handleNewDescriptionChange}
//             placeholder="Add new description"
//           />
//           <button className="add-btn" onClick={addDescription}>
//             Add
//           </button>
//         </div>
//       </div>

//       <button className="add-endpoint" onClick={addApiEndpoint}>
//         + Add API endpoint
//       </button>
//     </div>
//   );
// };

// export default APIForm;

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiFormActions } from "../../Store/onboard/apiFormSlice";
import "./apiendpoint1.css";

const APIForm = () => {
  const dispatch = useDispatch();
  const { optVaahan, category, link, apiDescription, newDescription } = useSelector(
    (state) => state.apiFormStore
  );

  const handleCheckboxChange = () => {
    console.log("125",optVaahan);
    
    dispatch(apiFormActions.setOptVaahan(!optVaahan));
  };

  const handleCategoryChange = (e) => {
    console.log("131",e.target.value);
    
    dispatch(apiFormActions.setCategory(e.target.value));
  };

  const handleLinkChange = (e) => {
    dispatch(apiFormActions.setLink(e.target.value));
  };

  const handleNewDescriptionChange = (e) => {
    dispatch(apiFormActions.setNewDescription(e.target.value));
  };

  const addDescription = () => {
    if (newDescription.trim() !== "") {
      dispatch(apiFormActions.addApiDescription(newDescription.trim()));
      dispatch(apiFormActions.setNewDescription("")); // Clear input after adding
    }
  };

  const removeDescription = (index) => {
    dispatch(apiFormActions.removeApiDescription(index));
  };

  const addApiEndpoint = () => {
    // Implement API endpoint addition logic here
  };

  return (
    <div className="api-form">
      <h2 className="api-heading">API</h2>

      <label className="checkbox-label">
        <input
          type="checkbox"
          checked={optVaahan}
          onChange={handleCheckboxChange}
        />
        <span className="checkbox-text">Opt for VAAHAN API</span>
      </label>

      <div className="input-group">
        <label>Category</label>
        <select value={category} onChange={handleCategoryChange}>
          <option value="Post">Post</option>
          <option value="Pre">Pre</option>
          <option value="Complete">Complete</option>
          <option value="Incomplete">Incomplete</option>
        </select>
      </div>

      <div className="input-group">
        <label>Link</label>
        <input
          type="text"
          value={link}
          onChange={handleLinkChange}
          placeholder="Enter API link"
        />
      </div>

      <div className="input-group">
        <label>API description</label>
        <div className="api-description">
          {apiDescription.map((desc, index) => (
            <span key={index} className="tag">
              {desc} {" "}
              <span
                className="remove-tag"
                onClick={() => removeDescription(index)}
              >
                ×
              </span>
            </span>
          ))}
        </div>
        <div className="add-description">
          <input
            type="text"
            value={newDescription}
            onChange={handleNewDescriptionChange}
            placeholder="Add new description"
          />
          <button className="add-btn" onClick={addDescription}>
            Add
          </button>
        </div>
      </div>

      <button className="add-endpoint" onClick={addApiEndpoint}>
        + Add API endpoint
      </button>
    </div>
  );
};

export default APIForm;
